import { useEffect, useState } from 'react';
import { resolveVideoUrl } from './utilityFunctions';

/**
 * Global click delegation for the `[data-trailer-url]` play buttons
 * (`SessionItem`, `AcademyCourse`, `JourneyItem`).
 *
 * BRAVON-6332 Phase 2b, Stage 7 — the url is resolved HERE, when the button is
 * clicked, not where the markup is rendered. Two reasons:
 *
 *  - a privatized teaser/replay is stored as the authenticated
 *    `/file/<type>/<id>` route, which a `<video src>` cannot send a Bearer
 *    token to; `resolveVideoUrl` re-bases it onto this portal's own
 *    session-gated `/file/*`, and returns every legacy public url untouched;
 *  - this is the ONE chokepoint every trigger passes through, so a new trailer
 *    button added anywhere cannot forget to resolve. Doing it in the three
 *    render sites instead would leave that gap open.
 */
export default function useTrailerTrigger() {
  const [trailerUrl, setTrailerUrl] = useState(null);

  useEffect(() => {
    const handler = e => {
      const trigger = e.target.closest('[data-trailer-url]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const url = resolveVideoUrl(trigger.getAttribute('data-trailer-url'));
      if (url) setTrailerUrl(url);
    };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, []);

  return [trailerUrl, () => setTrailerUrl(null)];
}
